import { HttpClient, JSON_STRING, jsonToFormData, MHTTPCL, createHttpGetOptions } from "../../../services/http/http-client";
export const DISTRIBUTION_URL = '/distribution.pl';
const JSONPAPI = '/jsonapi.pl'
const Orders = 'orders'
const RELATION = 'relation';
const MODIFICATION_URL = '/modify.pl'
export const OrderService = {

  ordershome: () => MHTTPCL.get(DISTRIBUTION_URL, {
    section: "orders",
    action: "home"
  }),
  loadEdiOrders: () => MHTTPCL.get(DISTRIBUTION_URL, {
    section: "orders",
    action: "load_edi_orders"
  }),

  getOrderList: () => HttpClient.get(DISTRIBUTION_URL, {
    section: Orders,
    action: "orders_tab_data",
    output: "json",
  }),
  modifyOrder: (kVal, name, value, table) => MHTTPCL.post(MODIFICATION_URL, {
    kVal: kVal,
    name: name,
    value: value,
    table: table
  }),
  deleteOrder: ({
    order_id
  }) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: Orders,
    action: 'remove_order',
    order_id: order_id
  }),

  addOrder: (order) => HttpClient.post(DISTRIBUTION_URL, {
    section: Orders,
    action: 'submit_order_data',
    ...order
  }),

  getOrdersFromBandcamp: () => MHTTPCL.get(DISTRIBUTION_URL, {
    section: "orders",
    action: "get_orders_from_bandcamp"
  }),

  getNewOrderData: () => HttpClient.get(DISTRIBUTION_URL, {
    section: Orders,
    action: "new_order_form_data",
    output: "json",
  }),
  getMultiOrders: () => HttpClient.get(DISTRIBUTION_URL, {
    section: Orders,
    action: "multi_account_order_modal",
    output: "json",
  }),

  filterMultAccountOrders: ({ accountId, status }) => HttpClient.get(DISTRIBUTION_URL, {
    section: Orders,
    action: "filter_multi_account_order_modal",
    account_id: accountId,
    status: status,
    output: "json",
  }),
  processMultiOrders: (multiOrder) => HttpClient.post(DISTRIBUTION_URL, {
    section: Orders,
    action: "process_multi_orders",
    data: JSON.stringify(multiOrder),
    output: "json",
  }),
  modifyShortfallQty: (orderline_id, shortfall_qty) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: Orders,
    action: "modify_shortfall_qty",
    orderline_id: orderline_id,
    shortfall_qty: shortfall_qty,
    output: "json",
  }),

  order_details: (orderId) => HttpClient.get(DISTRIBUTION_URL, {
    section: Orders,
    action: "order_details",
    order_id: orderId,
    output: "json",
  }),

  getEdiOrderProcessModalData: (orderId) => HttpClient.get(DISTRIBUTION_URL, {
    section: Orders,
    action: "get_edi_order_process_modal_data",
    order_id: orderId,
    output: "json",
  }),
  confirmEdiOrder: (orderId) => HttpClient.get(DISTRIBUTION_URL, {
    section: Orders,
    action: "confirm_edi_order",
    order_id: orderId,
    updated_data: [],
    output: "json",
  }),
  unConfirmEdiOrder: (orderId) => HttpClient.get(DISTRIBUTION_URL, {
    section: Orders,
    action: "unconfirm_edi_order",
    order_id: orderId,
    output: "json",
  }),
  sendConfirmedOrdersToEdi: (order_ids) => HttpClient.get(DISTRIBUTION_URL, {
    section: Orders,
    action: "send_confirmed_orders_to_edi",
    order_ids: order_ids,
    output: "json",
  }),
  sendShippingNotesToEdi: (order_ids) => HttpClient.get(DISTRIBUTION_URL, {
    section: Orders,
    action: "send_shipping_notes_to_edi",
    order_ids: order_ids,
    output: "json",
  }),

  sendInvoicesToEdi: (order_ids) => HttpClient.get(DISTRIBUTION_URL, {
    section: Orders,
    action: "send_invoices_to_edi",
    order_ids: order_ids,
    output: "json",
  }),

  ediRemoveRefused: (order_ids) => HttpClient.get(DISTRIBUTION_URL, {
    section: Orders,
    action: "edi_remove_refused",
    order_ids: order_ids,
    output: "json",
  }),

  ediSetToPrepare: (order_ids) => HttpClient.get(DISTRIBUTION_URL, {
    section: Orders,
    action: "edi_set_to_prepare",
    order_ids: order_ids,
    output: "json",
  }),

  getOrderlineFromData: ({ orderId }) => HttpClient.get(DISTRIBUTION_URL, {
    section: Orders,
    action: "orderline_form_data",
    order_id: orderId,
    output: "json",
  }),

  order_details_tab_overview: (orderId) => HttpClient.get(DISTRIBUTION_URL, {
    section: Orders,
    action: "order_details_tab_overview",
    order_id: orderId,
    output: "json",
  }),
  getOrderDetailsTabBaclOrdersByOrderId: ({ orderId }) => HttpClient.get(DISTRIBUTION_URL, {
    section: Orders,
    action: "order_details_tab_backorders",
    order_id: orderId,
    output: "json",
  }),
  order_details_tab_orderlines: (order_id) => MHTTPCL.get(DISTRIBUTION_URL, {
    section: Orders,
    action: "order_details_tab_orderlines",
    order_id: order_id,
    output: "json",
  }),
  order_details_tab_packing_shipping: (order_id) => HttpClient.get(DISTRIBUTION_URL, {
    section: Orders,
    action: "order_details_tab_packing_shipping",
    order_id: order_id,
    output: "json",
  }).then(res => {
    return {
      ...res,
      data: {
        stock_accounts: res.data.stock_accounts,
        accounts: res.data.accounts,
        currency: res.data.currency,
        order_types: res.data.order_types,
        order_status: res.data.order_status,
        currencies: res.data.currencies,
        price_list: res.data.price_list,
        invoice_projects: res.data.invoice_projects,
        payment_methods: res.data.payment_methods,
        orderline_pack_status: res.data.orderline_pack_status,
        shipping_types: res.data.shipping_types,
        account: res.data.account,
        order: res.data.order
        // package_stock_accounts: res.data.stock_accounts,
        // package_accounts:res.data.accounts,
        // package_currency:res.data.currency,
        // package_order_types:res.data.order_types,
        // package_order_status:res.data.order_status,
        // package_currencies:res.data.currencies,
        // package_price_list:res.data.price_list,
        // package_invoice_projects:res.data.invoice_projects,
        // package_payment_methods:res.data.payment_methods,
        // package_orderline_pack_status:res.data.orderline_pack_status,
        // package_shipping_types:res.data.shipping_types,
        // package_account:res.data.account,
        // package_order:res.data.order


      }
    };
  }),
  order_details_tab_summary: (orderId) => HttpClient.get(DISTRIBUTION_URL, {
    section: Orders,
    action: "order_details_tab_summary",
    order_id: orderId,
    output: "json",
  }),

  get_delivery_address: (orderId) => HttpClient.post(DISTRIBUTION_URL, {
    section: Orders,
    action: "get_delivery_address",
    order_id: orderId,
    output: "json",
  }),
  get_backorders: (order_id) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: Orders,
    action: "get_backorders",
    order_id: order_id,
    output: "json",
  }),
  get_orderlines: (order_id) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: Orders,
    action: "get_orderlines",
    order_id: order_id,
    output: "json",
  }),
  packing_orderlines: (order_id, status = "") => MHTTPCL.post(DISTRIBUTION_URL, {
    section: Orders,
    action: "packing_orderlines",
    order_id: order_id,
    status: status,
    output: "json",
  }),
  // .then(res => {
  //   return {
  //     ...res,
  //     data: {
  //       package_orderlines: res.data.orderlines,
  //     }
  //   };
  // }),
  getContactByOrderId: (contact_id) => MHTTPCL.post(JSONPAPI, {
    section: Orders,
    action: "get_contact",
    contact_id: contact_id,
    output: "json",
  }),

  getOrderTabData: () => HttpClient.get(DISTRIBUTION_URL, {
    section: Orders,
    action: "orders_tab_data",
    output: "json",
  }),

  getOrderlineStatusList: () => HttpClient.get(DISTRIBUTION_URL, {
    section: Orders,
    action: "orderline_status_list",
    output: "json",
  }),
  editOrderDeliveryInfo: (order_id, contact_id) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: 'orders',
    action: "edit_all_delivery_info",
    order_id: order_id,
    contact_id: contact_id,
    output: "json",
  }),
  getFilteredOrderList: (
    {
      searchString = "",
      order_month = "",
      accounted_period = "",
      account_id = "",
      status = "",
      is_shipped = "all",
      shipping_date = "",
      order_date_start = "",
      order_date_end = "",
      order_reference = "",
      edicot_only = '',
      start = 0,
      filterEmpty = false }) => HttpClient.post(DISTRIBUTION_URL, {
        section: Orders,
        action: "filter_order_list",
        order_search: searchString,
        order_month: order_month,
        accounted_period: accounted_period,
        account_id: account_id,
        status: status,
        is_shipped: is_shipped,
        shipping_date: shipping_date,
        order_date_start: order_date_start,
        order_date_end: order_date_end,
        order_reference: order_reference,
        edicot_only: edicot_only,
        start: start,
        filterEmpty: filterEmpty,
        output: "json"
      }),
  

     //  account_id=279
     //  status=to+prepare
     //  order_month=2023-09
     //  accounted_period=current_day
     //  order_date_start=2024-02-16
     //  order_date_end=2024-02-16
     //  shipping_date=2024-02-07
     //  is_shipped=shipped
     //  order_reference=653674727513+
     //  filterEmpty=false
     //  start=-1
     //  action=filter_order_list
     //  edicot_only=
     //  section=orders
    
  getFilteredOrderProducts: ({ order_id, str, product_type_id, label_id, artist, show_stock }) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: Orders,
    action: "search_order_products",
    order_id: order_id,
    str: str,
    product_type_id: product_type_id,
    label_id: label_id,
    artist: artist,
    show_stock: show_stock,
    output: "json"
  }),
  modify: (
    { key,
      kVal,
      name,
      value,
      table
    }
  ) => HttpClient.post(MODIFICATION_URL, {
    table: table,
    key: key,
    kVal: kVal,
    name: name,
    value: value,
    modified: new Date(),
    output: "json"
  }),
  getTemplates: (order_id) => HttpClient.get(DISTRIBUTION_URL, {
    section: "orders",
    action: "view_order_proforma_invoice_select_template",
    template_section: 'label',
    order_id: order_id,
    output: "json",
  }),
  checkGlnNo: (order_ids) => HttpClient.get(DISTRIBUTION_URL, {
    section: "orders",
    action: "check_gln_no",
    order_ids: order_ids,
    output: "json",
  }),
  checkBarcodesEdi: (order_ids) => HttpClient.get(DISTRIBUTION_URL, {
    section: "orders",
    action: "check_barcodes_edi",
    order_ids: order_ids,
    output: "json",
  }),
  exportEdiBarcodeCheckErrors: (order_ids) => HttpClient.postJSONasFormData(DISTRIBUTION_URL, {
    section: 'orders',
    action: 'export_edi_barcode_check_errors',
    order_ids: order_ids,
  }, createHttpGetOptions({ responseType: 'blob' })),

  addProdctsToOrder: ({ order_id, products }) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "orders",
    action: "add_products_to_order",
    order_id: order_id,
    products: JSON.stringify(products)

  }),

  loadOrderOrderlines: (order_id) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "orders",
    action: "load_order_orderlines",
    order_id: order_id,

  }),

  deleteOrderLine: ({ orderline_id, order_id }) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "orders",
    action: "delete_orderline",
    orderline_id: orderline_id,
    order_id: order_id,

  }),

  priceCodeDiscountModal: (order_id) => MHTTPCL.get(DISTRIBUTION_URL, {
    section: "orders",
    action: "price_code_discount_modal",
    order_id: order_id,
    output: "json"
  }),

  udpatePriceCodeDiscount: ({ order_id, price_codes }) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "orders",
    action: "udpate_price_code_discount",
    order_id: order_id,
    price_codes: JSON.stringify(price_codes)

  }),

  deleteBackOrder: ({ order_id, backorder_id }) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "orders",
    action: "delete_backorder",
    backorder_id: backorder_id,
    order_id: order_id

  }),

  orderlineStatusList: () => MHTTPCL.post(DISTRIBUTION_URL, {
    action: "orderline_status_list",
    section: "orders"

  }),





  autoBackorderFromPacking: (order_id, orderlines) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "orders",
    action: "auto_backorder_from_packing",
    order_id: order_id,
    orderlines: JSON.stringify(orderlines)

    //"[{\"orderline_id\":\"3337\",\"status\":\"\",\"product_id\":\"87\",\"product_allowed_country_account_show\":\"\",\"account_stock_unpacked_unreserved\":\"-409000\",\"order_qty\":\"20\"},{\"orderline_id\":\"3338\",\"status\":\"\",\"product_id\":\"87\",\"product_allowed_country_account_show\":\"\",\"account_stock_unpacked_unreserved\":\"-409000\",\"order_qty\":\"20\"},{\"orderline_id\":\"3339\",\"status\":\"\",\"product_id\":\"87\",\"product_allowed_country_account_show\":\"\",\"account_stock_unpacked_unreserv…\"status\":\"\",\"product_id\":\"85\",\"product_allowed_country_account_show\":\"\",\"account_stock_unpacked_unreserved\":\"-21\",\"order_qty\":\"10\"},{\"orderline_id\":\"3346\",\"status\":\"\",\"product_id\":\"85\",\"product_allowed_country_account_show\":\"\",\"account_stock_unpacked_unreserved\":\"-21\",\"order_qty\":\"40\"},{\"orderline_id\":\"3347\",\"status\":\"\",\"product_id\":\"85\",\"product_allowed_country_account_show\":\"\",\"account_stock_unpacked_unreserved\":\"-21\",\"order_qty\":\"20\"}]"


  }),

  updatePickStatus: ({ order_id, status, orderlines }) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "orders",
    action: "update_pick_status",
    order_id: order_id,
    status: status,
    orderlines: JSON.stringify(orderlines)

  }),

  addBackorders: ({ backorders, order_id }) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "orders",
    action: "add_backorders",
    backorders: JSON.stringify(backorders),
    order_id: order_id

  }),

  shippingNotify: (selectdOrderIds, selectedAll = 0, shipping_agent) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "plugin",
    action: "shippingNotify",
    selectdOrderIds: selectdOrderIds,
    selectedAll: selectedAll,
    shipping_agent: shipping_agent
  }),

  getProductForBandcampOrderModal: (search = '') => MHTTPCL.get(DISTRIBUTION_URL, {
    section: "orders",
    action: "get_product_for_bandcamp_order_modal",
    search: search
  }),

  vatTerritories: () => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "orders",
    action: "vat_territories"
  }),


  modifyVatTerritory: (kVal, vat_territory) => MHTTPCL.post(MODIFICATION_URL, {
    modify_type: "record",
    table: "l_orders",
    kVal: kVal,
    vat_territory: vat_territory
  }),


  checkContraAccountId: (order_id) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "orders",
    action: "check_contra_account_id",
    order_id: order_id
  }),

  accountOrder: (order_id, accounted_date) => MHTTPCL.post(DISTRIBUTION_URL, {
    action: "account_order",
    order_id: order_id,
    accounted_date: accounted_date,
    section: "orders"
  }),
  orderlines_without_price: (order_id, accounted_date) => MHTTPCL.post(DISTRIBUTION_URL, {
    action: "orderlines_without_price",
    order_id: order_id,
    section: "orders"
  }),

  productAvailableStock: ({ order_id, product_ids }) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: 'orders',
    action: 'product_available_stock',
    order_id: order_id,
    products: JSON.stringify(product_ids)
  }),

  //new autobackorder
  autoBackorder: (order_id) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "orders",
    action: "auto_backorder",
    order_id: order_id
  }),




  // Reopen Order
  // action	"reopen_order"
  // order_id	"1911"
  // section	"orders"
  reopen_order: (order_id) => MHTTPCL.post2(DISTRIBUTION_URL, {
    section: "orders",
    action: "reopen_order",
    order_id: order_id
  }),

  order_shipping_status: (order_id) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "orders",
    action: "order_shipping_status",
    order_id: order_id
  }),
  account_shipping_costs_modal: (order_id) => MHTTPCL.get2(DISTRIBUTION_URL, {
    section: "orders",
    action: "account_shipping_costs_modal",
    output: "json",
    order_id: order_id
  }),
  shipping_costs_invoice: (order_id, shipping_costs) => MHTTPCL.get2(DISTRIBUTION_URL, {
    section: "orders",
    action: "shipping_costs_invoice",
    output: "json",
    order_id: order_id,
    shipping_costs: shipping_costs,
  }),
  shipping_costs_royalty_account: (order_id, shipping_costs, royalty_account_id) => MHTTPCL.get2(DISTRIBUTION_URL, {
    section: "orders",
    action: "shipping_costs_royalty_account",
    output: "json",
    order_id: order_id,
    shipping_costs: shipping_costs,
    royalty_account_id: royalty_account_id,
  }),

  /////////

  calculateWeight: (order_id) => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "orders",
    action: "calculate_weight",
    order_id: order_id,
    output: JSON_STRING
  }),

  physicalProducts: () => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "orders",
    action: "physical_products",
    output: JSON_STRING
  }),

  exportUnmatchedOrderlinesOnImport: (order_id, proudcts) => MHTTPCL.postJSONasFormData(DISTRIBUTION_URL, {
    section: 'orders',
    action: 'export_unmatched_orderlines_on_import',
    order_id: order_id,
    products: JSON.stringify(proudcts)

  }, createHttpGetOptions({
    //noJsonOutput: true,
    responseType: 'blob'
  })),

  fetchAdvancedSearchData: () => MHTTPCL.post(DISTRIBUTION_URL, {
    section: "orders",
    action: "order_advanced_search",
  }),



































  //     action	"auto_backorder_from_packing"
  // order_id	"1874"
  // orderlines	"[{\"orderline_id\":\"3337\",\"status\":\"\",\"product_id\":\"87\",\"product_allowed_country_account_show\":\"\",\"account_stock_unpacked_unreserved\":\"-409000\",\"order_qty\":\"20\"},{\"orderline_id\":\"3338\",\"status\":\"\",\"product_id\":\"87\",\"product_allowed_country_account_show\":\"\",\"account_stock_unpacked_unreserved\":\"-409000\",\"order_qty\":\"20\"},{\"orderline_id\":\"3339\",\"status\":\"\",\"product_id\":\"87\",\"product_allowed_country_account_show\":\"\",\"account_stock_unpacked_unreserv…\"status\":\"\",\"product_id\":\"85\",\"product_allowed_country_account_show\":\"\",\"account_stock_unpacked_unreserved\":\"-21\",\"order_qty\":\"10\"},{\"orderline_id\":\"3346\",\"status\":\"\",\"product_id\":\"85\",\"product_allowed_country_account_show\":\"\",\"account_stock_unpacked_unreserved\":\"-21\",\"order_qty\":\"40\"},{\"orderline_id\":\"3347\",\"status\":\"\",\"product_id\":\"85\",\"product_allowed_country_account_show\":\"\",\"account_stock_unpacked_unreserved\":\"-21\",\"order_qty\":\"20\"}]"
  // section	"orders"

















}